import React, { createRef } from "react";
import ReactDOM from "react-dom";
import BootstrapModal from "bootstrap/js/dist/modal";

interface ModalControls {
    close: () => void;
}

interface Props {
    forceReload?: boolean;
    nofade?: boolean;
    header?: React.ReactNode;
    footer?: React.ReactNode;
    onShow?: () => void;
    onHide?: () => void;
    verticallyCentered?: boolean;
    children?: React.ReactNode | ((modal: ModalControls) => React.ReactNode);
    size?: "sm" | "lg" | "xl" | "fullscreen"
}
interface State {
    hasOpened: boolean;
}

export class Modal extends React.Component<Props, State> {
    private isModalLoaded: boolean;
    private isUnmouting: boolean;
    private isClosing: boolean;
    private modalDiv: HTMLDivElement;
    private body: HTMLBodyElement;

    private modal = React.createRef<HTMLDivElement>();

    constructor(props: Props) {
        super(props);
        this.state = {
            hasOpened: false
        }
        this.body = document.getElementsByTagName("body")[0];
        this.modalDiv = document.createElement('div');
    }

    private modalElement() {
        const modal = ReactDOM.findDOMNode(this.modal.current) as Element;
        return modal ? BootstrapModal.getOrCreateInstance(modal) : null;
    }

    open() {
        this.modalElement()?.show();
        if (!this.state.hasOpened)
            this.setState({ hasOpened: true });
    }

    close() {
        if (!this.isClosing)
            this.modalElement()?.hide();

        this.destroy();
    }

    private destroy = () => {
        if (this.isUnmouting) {
            this.unbindModalEvents();
            this.body.removeChild(this.modalDiv);
            this.isUnmouting = false;
        }
    }

    private closingModal = () => {
        this.isClosing = true;
    }

    private showModal = () => {
        this.forceUpdate();
        if (this.props.onShow)
            this.props.onShow();
    }

    private hideModal = () => {
        this.isClosing = false;

        this.modalElement()?.hide();
        if (this.props.forceReload) {
            this.setState({ hasOpened: false }, () => {
                if (this.props.onHide)
                    this.props.onHide();
            })
        }
        else if (this.props.onHide)
            this.props.onHide();

        this.destroy();
    };

    bindModalEvents = () => {
        if (!this.isModalLoaded && this.state.hasOpened) {
            const modal = ReactDOM.findDOMNode(this.modal.current);
            if (modal) {
                modal.addEventListener("shown.bs.modal", this.showModal);
                modal.addEventListener("hidden.bs.modal", this.hideModal);
                modal.addEventListener("hide.bs.modal", this.closingModal);

                this.isModalLoaded = true;
            }
        }
    }

    unbindModalEvents = () => {
        if (this.isModalLoaded) {
            const modal = ReactDOM.findDOMNode(this.modal.current);
            if (modal) {
                modal.removeEventListener("shown.bs.modal", this.showModal);
                modal.removeEventListener("hidden.bs.modal", this.hideModal);
                modal.removeEventListener("hide.bs.modal", this.closingModal);
            }
        }
    }

    componentDidMount() {
        this.bindModalEvents();
        this.body.appendChild(this.modalDiv);
    }

    componentWillUnmount() {
        this.isUnmouting = true;
        this.close();
    }

    componentDidUpdate(prevProps: Props, prevState: State) {
        this.bindModalEvents();
        if (!prevState.hasOpened && this.state.hasOpened) {
            this.modalElement()?.show();
        }
    }

    // shouldComponentUpdate(nextProps: ModalProps, nextState: OpenModalButtonState) {
    //     if (this.isVisible)
    //         return true;
    //     return nextProps.forceReload || !this.state.hasOpened || (nextState.hasOpened && !this.state.hasOpened);
    // }

    render() {
        const { size, verticallyCentered } = this.props;
        const sizeClass = size != undefined ? `modal-${size}` : "modal-lg";
        const className = `modal-fullscreen-md-down ${sizeClass} ${verticallyCentered ? "modal-dialog-centered" : ""}`;

        return ReactDOM.createPortal(this.state.hasOpened
            ? <div ref={this.modal} role="dialog" className={"modal " + (this.props.nofade ? "" : "fade")} onClick={e => e.stopPropagation()}>
                <div className={`modal-dialog ${className} `}>
                    <div className="modal-content">
                        {
                            this.props.header != null
                                ? <div className="modal-header bg-theme text-white">{this.props.header}</div>
                                : null
                        }
                        <div className="modal-body" id="modal-body">
                            {typeof this.props.children == "function" ? this.props.children({ close: () => this.close() }) : this.props.children}
                        </div>
                        <div className="modal-footer">
                            {this.props.footer || <button type="button" className="btn btn-secondary" onClick={e => {
                                e.stopPropagation();
                                this.close();
                            }}>Chiudi</button>}
                        </div>
                    </div>
                </div>
            </div>
            : null, this.modalDiv);
    }
}

export function openModal(text: (controls: ModalControls) => React.ReactNode, title?: string) {
    const wrapper = document.body.appendChild(document.createElement("div"));
    const onHide = () => {
        ReactDOM.unmountComponentAtNode(wrapper);
        setTimeout(_ => wrapper.remove(), 500);
    };
    const modal = createRef<Modal>();
    ReactDOM.render(<Modal
        header={title}
        onHide={onHide}
        nofade ref={modal}
        footer={<></>}
    >
        {text}
    </Modal>, wrapper, () => modal.current?.open());
}